<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Afvis posteringer</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline" class="mdc-textarea-fix">
        <mat-label>Bemærkning</mat-label>

        <textarea id="note" placeholder="" formControlName="note" rows="2" matInput type="text"></textarea>
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">OK</button>
  <button mat-raised-button mat-dialog-close>Fortryd</button>
</div>
